import React from 'react';
import Type from 'prop-types';
import cn from 'classnames';
import { isDate, isEmpty } from 'lodash';
import { isToday, isBefore, isThisWeek } from 'date-fns';
import { getRelativeDateTime } from 'utils/date';
import styles from './DueDate.module.css';

const DueDate = (props) => {
  const { showDate, showTime, due: rawDue, dataTestId } = props;

  if (isEmpty(rawDue) || (!showDate && !showTime)) {
    return null;
  }

  const due = isDate(rawDue) ? rawDue : new Date(rawDue);
  const now = new Date();
  const isExpired = isBefore(due, now);
  const { date, time } = getRelativeDateTime(due);

  return (
    <span
      className={cn({
        [styles.dateToday]: !isExpired && isToday(due),
        [styles.dateFuture]: !isExpired && !isToday(due) && isThisWeek(due),
        [styles.dateOverdue]: isExpired,
      })}
      data-testid={dataTestId}
    >
      {showDate && <span className={styles.dateLabel}>{date}</span>}
      {showTime && <span>{time}</span>}
    </span>
  );
};

DueDate.propTypes = {
  due: Type.oneOfType([Type.string, Type.instanceOf(Date)]).isRequired,
  showDate: Type.bool.isRequired,
  showTime: Type.bool.isRequired,
  dataTestId: Type.string,
};

DueDate.defaultProps = {
  dataTestId: null,
};

export default DueDate;
